<style lang="less" scoped>
.getso {
	background-color: #1fae66 !important;
}

// /deep/ .el-table__row{
// 	div{
// 		cursor:crosshair ;
// 	}
// }

.bordera {
	opacity: 0;
	// transform: translateX(-100px);
	width: 10px;
}

.borderb {
	opacity: 1;
	width: 100%;
}

.borderc {
	transition: all 3s;
}

.promise {
	padding: 1rem 6rem 6rem;
	width: 100%;
	background-color: #fff;
	box-sizing: border-box;
	border-top: 4px solid #0acf97;
	border-top-width: 1%;
	border-radius: 2px;
	margin-bottom: 1rem;

	// text-align: center;
	/deep/ .el-step__head.is-wait {
		.el-step__icon.is-text {
			background: #dddddd;
			color: #fff;
		}
	}

	/deep/ .el-step.is-horizontal .el-step__line {
		top: 28px;
	}

	/deep/ .el-step__head.is-process {
		.el-step__icon.is-text {
			background-color: #37a000;
			color: #333;
			color: #fff;
			font-size: 1.4rem;
			border-color: transparent;
		}
	}

	/deep/ .el-step__head.is-process {
		.el-step__icon.is-success {
			border-color: #67c23a;
			background: #37a000 !important;
		}
	}

	/deep/ .el-step__icon.is-text {
		padding: 1.6rem;
		border: 0;
	}

	.promisetitle {
		margin: 1.2rem 0;
		width: 100%;
		text-align: center;

		p:first-child {
			font-size: 1.2rem;
			color: #333;
			font-weight: 700;
			margin-bottom: 0.8rem;
		}
	}

	.promitable {
		/deep/ .el-table {
			th,
			td {
				text-align: center;
			}
		}
	}

	.ckll {
		margin-top: 1rem;

		button {
			background: #f89c2c;
			color: #fff;
		}
	}
}

.choicedate {
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 0.6rem 0.4rem;
	margin: 2rem 0 1rem;
	color: #333;
	border-radius: 2px;
	box-sizing: border-box;
	border: 1px solid #ccc;

	p {
		margin: 0 1rem;
	}
}

.choicedmessage {
	padding: 1rem 0.4rem;
	border: 1px solid #ccc;
	box-sizing: border-box;

	.choicedtimer {
		display: flex;
		align-items: center;
		margin: 1rem 0.4rem;

		p {
			width: 7rem;
		}
	}

	.choicedtimers {
		align-items: flex-start;
	}
}

/deep/ .tablestitle {
	color: #333;

	.cell {
		font-weight: 600 !important;
	}

	// font-size: 1rem;
}
</style>

<template>
	<div>
		<titles titlename="我要预约" titlecontent="这里可以预约课程,以及查看预约的信息" :mbx="paths"></titles>
		<strong></strong>

		<transition appear enter-class="bordera" enter-active-class="borderc" enter-to-class="borderb">
			<div class="promise">
				<div class="promisetitle">
					<p>{{ roomname }}预约流程</p>
					<p>填写预约资料，以获得实训机会</p>
				</div>
				<div class="promisecenter">
					<el-steps align-center :active="active" finish-status="success">
						<el-step title="选择实训设备"></el-step>
						<el-step title="选择日期"></el-step>
						<el-step title="填写资料"></el-step>
					</el-steps>
				</div>
				<div class="promitable" v-if="active == 0">
					<template v-if="this.roomname == '实训设备'">
						<el-table :data="tableData" header-row-class-name="tablestitle" style="width: 100%; text-align: center;">
							<el-table-column type="index" :index="indexMethod" label="序号" width="50"></el-table-column>
							<el-table-column prop="te_deviceNumber" label="实训设备编号"></el-table-column>
							<el-table-column prop="te_deviceName" label="实训设备名称"></el-table-column>
							<el-table-column prop="sx_tr_name" label="所属实训室"></el-table-column>
							<el-table-column label="操作" width="100">
								<template slot-scope="scope">
									<el-button v-if="scope.row.te_deviceState == 0" type="info" size="mini" @click="notpromise(scope.$index, scope.row)">预约</el-button>
									<el-button v-if="scope.row.te_deviceState == -1" type="info" size="mini" @click="notpromise(scope.$index, scope.row)">预约</el-button>
									<el-button
										v-if="scope.row.te_deviceState !== -1 && scope.row.te_deviceState !== 0"
										type="success"
										size="mini"
										@click="handleEdit(scope.$index, scope.row)"
									>
										预约
									</el-button>
								</template>
							</el-table-column>
						</el-table>
					</template>

					<template v-if="this.roomname == '实训室'">
						<el-table :data="tableData" header-row-class-name="tablestitle" style="width: 100%; text-align: center;">
							<el-table-column type="index" :index="indexMethod" label="序号" width="50"></el-table-column>
							<el-table-column prop="tr_billNo" label="实训室编号"></el-table-column>
							<el-table-column prop="tr_name" label="实训室名称"></el-table-column>
							<el-table-column prop="tr_address" label="实训室地址"></el-table-column>
							<el-table-column label="操作" width="100">
								<template slot-scope="scope">
									<!-- <el-button v-if="scope.row.te_deviceState == 0" type="info" size="mini"
										@click="notpromise(scope.$index, scope.row)">
										预约</el-button>
									<el-button v-if="scope.row.te_deviceState == -1" type="info" size="mini"
										@click="notpromise(scope.$index, scope.row)">
										预约</el-button> -->
									<el-button v-if="!scope.row.tr_isOpen" type="info" size="mini" @click="notpromise(scope.$index, scope.row)">预约</el-button>

									<el-button v-if="scope.row.tr_isOpen" type="success" size="mini" @click="handleEdit(scope.$index, scope.row)">预约</el-button>
								</template>
							</el-table-column>
						</el-table>
					</template>
				</div>

				<div class="datetable" v-if="active == 1">
					<div>
						<div class="choicedate">
							<p>实训{{ this.roomname == '实训设备' ? '设备' : '室' }} 编号：{{ trainsbtimohbj.te_deviceNumber ?? trainsbtimohbj.tr_billNo }}</p>
							<p>{{ this.roomname == '实训设备' ? '设备名称' : '实训室名称' }}：{{ trainsbtimohbj.te_deviceName ?? trainsbtimohbj.tr_name }}</p>
						</div>
						<FullCalendar :oknumlist="oknumlists" :powerlist="tainpowrjl"></FullCalendar>
					</div>
				</div>

				<div class="datetable" v-if="active == 2">
					<div>
						<div class="choicedate">
							<p>实训名称： {{ trainsbtimohbj.sx_tr_name ?? trainsbtimohbj.tr_name }}</p>
							<p>预约日期： {{ timersdate }}</p>
							<p>可预约时间段： {{ strattimers }} ~ {{ endtimer }}</p>
						</div>
						<div class="choicedmessage">
							<el-row :gutter="40">
								<el-col :span="24">
									<div class="choicedtimer">
										<p>预约时间：</p>

										<div class="block" style="margin-right: 10%;">
											<el-select v-model="timersall" placeholder="请选择时间段">
												<el-option v-for="item in timerlists" :key="item.value" :value="item.value" :disabled="item.disabled"></el-option>
											</el-select>
										</div>

										<!-- <div class="block" style="margin-right: 10%;">
											<p>预约开始时间</p>
											<el-time-select
												v-model="strattimer"
												:picker-options="{
													start: strattimers,
													step: '00:30',
													end: endtimers
												}"
												placeholder="选择时间"
											></el-time-select>
										</div>

										<div class="block">
											<p>预约结束时间</p>
											<el-time-select
												v-model="endtimers"
												:picker-options="{
													start: strattimer,
													step: '00:30',
													end: endtimer
												}"
												placeholder="选择时间"
											></el-time-select>
										</div> -->
									</div>
								</el-col>
							</el-row>
							<el-row :gutter="20">
								<el-col :span="12">
									<div class="choicedtimer">
										<div class="peoplenum"><p>预约人数：</p></div>
										<input
											v-model="peoplenum"
											type="number"
											:oninput="'if(value>' + tsnumbers + ')value=' + tsnumbers + ';if(value<2)value=1'"
											class="form-control"
										/>
									</div>
								</el-col>
							</el-row>
							<el-row :gutter="20">
								<el-col :span="24">
									<div class="choicedtimer choicedtimers">
										<div class="peoplenum"><p>预约申请说明：</p></div>
							 			<textarea v-model="appContent" class="form-control" id="exampleFormControlTextarea1" rows="8"></textarea>
									</div>
								</el-col>
							</el-row>
						</div>
					</div>
				</div>
				<div class="ckll">
					<el-button v-if="active != 0" style="margin-top: 12px;" @click="prevnext" :disabled="nextbllom">
						<span class="el-icon-caret-left" style=" margin-right: 10px; border: 1px solid #ccc;color: #b4b4b4; background: #fff; border-radius: 50%;"></span>
						上一步
					</el-button>
					<el-button v-if="active != 0" :class="{ getso: nexttext == '提交' }" style="margin-top: 12px;" @click="nextt" :disabled="nextbllomn" v-preventReClick>
						<span
							:class="{ 'el-icon-check': active == 2 }"
							v-if="nexttext == '提交'"
							style="margin-right: 10px;border: 1px solid #ccc;color: #b4b4b4; background: #fff; border-radius: 50%;"
						></span>
						{{ nexttext }}
						<span
							v-if="nexttext != '提交'"
							class="el-icon-caret-right"
							style="margin-left: 10px;border: 1px solid #ccc;color: #b4b4b4; background: #fff; border-radius: 50%;"
						></span>
					</el-button>
				</div>
			</div>
		</transition>
	</div>
</template>

<script>
import titles from '@/components/title/title.vue';
import FullCalendar from '@/pageme/Calendar.vue';
import {
	GetbfyTrainEquipmentLists,
	GetAppointmentCount,
	GetscTrainingSetSingle,
	getUserAppointment,
	getbfyGetTrainList,
	GetTrainingroomSetSingle,
	GetAppointmentroomCount,
	TrainGetSetting,
	TrainEquipmentGetSetting
} from '@/request/api/trainroom/trainroom.js';

import AppOptions from '@/config/AppOptions.vue';

import $ from 'jquery';

export default {
	data() {
		return {
			oknumlists: [],
			trainsbtimohbj: {},
			// 时间选择
			value2: '',
			active: 0,
			// 标题组件
			paths: [
				{
					path: '/usercenter/mypromise',
					name: '我要预约'
				}
			],
			// 标题选择设备
			tableData: [],
			// 判断上一步下一步
			nextbllom: false,
			nextbllomn: false,
			nexttext: '下一步',
			// 当前设备预约记录
			tainpowrjl: [],
			// 实训记录
			Training: {},
			// 预约对象传递
			strattimer: '',
			endtimer: '23:00',
			timersdate: '',
			peoplenum: 1,
			appContent: '',
			endtimers: '12:00',
			strattimers: '08:00',
			timersall: '',
			roomname: '',
			tsnumbers: '',
			timerlists: [],
			// 获取实训室实训设备
			teguid: '',
			trguid: ''
		};
	},
	created() {
		AppOptions.appEmpty = false;
	},
	beforeMount() {
		this.roomname = this.$route.query.roomname;
		if (this.roomname == '实训室') {
			getbfyGetTrainList(localStorage.getItem('siguid')).then(res => {
				// console.log(res, "实训室不分页")
				this.tableData = res.data.data;
			});
		} else {
			GetbfyTrainEquipmentLists(localStorage.getItem('siguid')).then(res => {
				// console.log(res, "设备不分页")
				this.tableData = res.data.data;
			});
		}
	},
	mounted() {},

	watch: {
		active(val) {
			if (val == 2) {
				this.nexttext = '提交';
			} else if (val > 2) {
				this.nextbllom = true;
			}
		}
	},
	methods: {
		// 获取timerlist
		sertimerlist(list) {
			// let start = 8;
			// let end = 23;
			let timeArray = [];
			timeArray = list.map(item => {
				let istiumer = parseInt(item.number - item.ynumber) <= 0;

				let objs = {
					value: item.s_time + '~' + item.e_time,
					disabled: istiumer
				};
				return objs;
			});
			// parseInt(item.number - item.ynumber) =< 0
			// console.log(timeArray, '获取时间段');
			if (timeArray.length > 0) {
				this.timersall = timeArray.filter(item => !item.disabled)[0].value;
			}
			this.timerlists = timeArray;
		},
		// 不可预约
		notpromise() {
			this.$message('当前实训室是处于关闭状态，不可预约');
		},
		// 更改预约
		changetimer(timers) {
			// console.log(timers);
			if (timers.names == 1) {
				this.nextbllomn = false;
				this.timersdate = timers.dates;
			} else {
				this.nextbllomn = true;
			}
		},

		// 索引
		indexMethod(index) {
			return index + 1;
		},
		// 上一步下一步
		prevnext() {
			this.nextbllomn = false;

			if (this.roomname == '实训设备') {
				GetAppointmentCount(this.trainsbtimohbj.sx_te_guid).then(res => {
					// console.log(res)
					if (res.data.data && res.data.data.length > 0) {
						// console.log("获取设备预约")
						this.tainpowrjl = res.data.data;
					}
				});
			} else {
				GetAppointmentroomCount(this.trainsbtimohbj.sx_tr_guid).then(res => {
					// console.log(res)
					if (res.data.data && res.data.data.length > 0) {
						// console.log("获取实训室预约")
						// this.nextbllomn = true
						this.tainpowrjl = res.data.data;
					}
				});
			}

			if (this.active == 0) {
				this.nextbllom = true;
			} else if (this.nexttext == '提交') {
				this.nexttext = '下一步';
				this.active = 1;
				this.timersdate = '';
			} else {
				this.active--;
			}
			// console.log(this.active)
		},
		nextt() {
			// console.log(this.timersdate + " " + this.endtimers)
			// console.log(new Date(this.timersdate + " " + this.endtimers).valueOf())
			// console.log(new Date().valueOf())

			this.nextbllom = false;
			if (this.active == 2) {
				if (this.appContent !== '' && this.timersall != '') {
					// if (new Date(this.timersdate + ' ' + this.endtimers).valueOf() < new Date().valueOf()) {
					// 	this.$message('预约结束时间不能小于当前时间');
					// 	return;
					// }
					// console.log(this.timersall,'获取时间')
					this.strattimer = this.timersall.split('~')[0];
					this.endtimers = this.timersall.split('~')[1];
					// console.log(this.strattimer,this.endtimers)
					let aponintobj = {
						ap_applicantGuid: localStorage.getItem('uiguid'),
						ap_startTime: this.strattimer,
						ap_endTime: this.endtimers,
						ap_reservedNum: this.peoplenum,
						ap_appContent: this.appContent,
						ap_appDate: this.timersdate.split('-').join('/'),
						sx_te_guid: this.roomname == '实训室' ? this.trainsbtimohbj.sx_tr_guid : this.trainsbtimohbj.sx_te_guid,
						ap_type: this.roomname == '实训室' ? 0 : 1
					};
					// console.log(aponintobj)

					getUserAppointment(aponintobj).then(res => {
						// console.log(res)
						if (res.data.code == 1) {
							this.$message({
								message: '恭喜你，' + res.data.msg,
								type: 'success'
							});
							// console.log("已完成")
							this.$router.push({
								path: '/usercenter/myuserpromise'
							});
						} else {
							this.$message(res.data.msg);
						}
					});
				} else {
					this.$message('请输入说明与开始时间');
				}
			} else if (this.active == 1) {
				var date = new Date();
				date.getYear(); //获取当前年份(2位)
				let years = date.getFullYear(); //获取完整的年份(4位)
				let tmonth = date.getMonth() + 1; //获取当前月份(0-11,0代表1月)
				let dates = date.getDate(); //获取当前日(1-31)
				let datatimer = years + '-' + tmonth + '-' + dates;

				if (this.timersdate) {
					if (new Date(this.timersdate) < new Date(datatimer)) {
						this.$message('预约日期不能小于当前时间');
						this.nextbllom = true;
					} else if (new Date(this.timersdate) >= new Date(datatimer)) {
						// this.$message("比当前日期后")
						this.nextbllom = false;
						this.gettimerslist(this.timersdate);
						// console.log(this.timerlists,'获取')
						// // return
					}
				} else {
					this.$message('未选择日期');
				}
			}

			/* else {
					this.active++
				} */
		},
		gettimerslist(timer) {
			if (this.roomname == '实训设备') {
				let timersobj = {
					sx_te_guid: this.teguid,
					app_time: timer
				};
				TrainEquipmentGetSetting(timersobj).then(res => {
					// console.log(res,'获取实训设备')
					if (res.data.data.sxTimeconfiguration.length > 0) {
						this.sertimerlist(res.data.data.sxTimeconfiguration);
						this.active = 2;
					} else {
						this.$message('您预约的实训设备暂无配置时间，请联系管理员');
					}
				});
			} else {
				let timersobjs = {
					sx_tr_guid: this.trguid,
					app_time: timer
				};

				TrainGetSetting(timersobjs).then(res => {
					// console.log(res,'获取实训室')
					if (res.data.data.sxTimeconfiguration.length > 0) {
						this.sertimerlist(res.data.data.sxTimeconfiguration);
						this.active = 2;
					} else {
						this.$message('您预约的实训室暂无配置时间，请联系管理员');
					}
				});
			}
		},

		handleEdit(index, item) {
			// console.log(item)
			this.active = 1;
			this.trainsbtimohbj = item;
			if (this.roomname == '实训设备') {
				this.teguid = item.sx_te_guid;
				GetAppointmentCount(item.sx_te_guid).then(res => {
					// console.log(res)
					if (res.data.data && res.data.data.length > 0) {
						// console.log("获取设备预约")
						this.nextbllomn = true;
						this.tainpowrjl = res.data.data;
						// console.log(this.tainpowrjl,'获取实训设备111')
					}
				});
				GetscTrainingSetSingle(item.sx_te_guid).then(res => {
					// console.log(res, "当前实训室所需时间段")
					if (res.data.data) {
						this.oknumlists = res.data.data.sx_ts_trainCycle.split(',');
						this.strattimers = res.data.data.sx_ts_startTime;
						// this.endtimer = res.data.data.sx_ts_endTime;
						// this.strattimer = res.data.data.sx_ts_startTime;
						// this.sertimerlist(res.data.data.sxTimeconfiguration);
					}
				});
			} else {
				this.trguid = item.sx_tr_guid;
				GetAppointmentroomCount(item.sx_tr_guid).then(res => {
					// console.log(res)
					if (res.data.data && res.data.data.length > 0) {
						// console.log("获取实训室预约")
						this.nextbllomn = true;
						this.tainpowrjl = res.data.data;
					}
				});

				GetTrainingroomSetSingle(item.sx_tr_guid).then(res => {
					// console.log(res, '当前实训室所需时间段');
					if (res.data.data) {
						this.oknumlists = res.data.data.sx_ts_trainCycle.split(',');
						this.strattimers = res.data.data.sx_ts_startTime;
						// this.endtimer = res.data.data.sx_ts_endTime;
						// this.strattimer = res.data.data.sx_ts_startTime;
						this.tsnumbers = res.data.data.sx_ts_number;
						// this.sertimerlist(res.data.data.sxTimeconfiguration);
					}
				});
			}
		}
	},
	components: {
		titles,
		FullCalendar
	}
};
</script>
